module.exports = require("core-js/library/fn/object/define-properties");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/object/define-properties.js
// module id = 178
// module chunks = 0 1